
import { Component, Vue, Ref } from 'vue-property-decorator'
import { IReporterItemData } from '@/types/reporter-types'
import { ReporterService, MediaService } from '@/services/index'
import QueryString from 'query-string'
import TableHeader from '@/components/table_header/index.vue'
import ReporterTable from './components/reporterTable.vue'
import FullLoading from '@/components/full_loading/index.vue'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'

@Component({
    name: 'Reporters',
    components: {
        ReporterTable,
        TableHeader,
        FullLoading,
        ScrollTo
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType
    private reporters: IReporterItemData[] = []
    private status: string = 'pending'
    private searchForm = {
        media: {
            id: '',
            name: ''
        },
        reporterName: ''
    }
    private typeOptions = [
        { value: '', label: '所有身份' },
        { value: 0, label: '记者' },
        { value: 1, label: '特邀记者' },
        { value: 2, label: '通讯员' },
        { value: 3, label: '投稿作者' },
        { value: 4, label: '实习生' }
    ]
    private curType = ''
    private limitCountOptions = [{
        value: '',
        label: '所有记者'
    }, {
        value: 0,
        label: '0篇文章'
    }, {
        value: 1,
        label: '只有1篇文章'
    }, {
        value: 3,
        label: '文章少于3篇'
    }, {
        value: 7,
        label: '文章少于7篇'
    }]
    private limitCount = ''
    private pageIndex: number = 1
    private pageSize: number = 50
    private pageTotal: number = 0
    private loading: boolean = true
    private tableHeaderDecs: string = ''
    private mediasOptions = []
    private mediaSearchLoading: boolean = false
    private searchTimer: number | null = null
    private lastSearchQuery: string = ''

    private prePage!: number

    created() {
        this.prePage = this.pageIndex
    }
    private mounted() {
        this.initData()
    }

    private initData() {
        const rParams: any = QueryString.parse(location.search)
        if (rParams.mediaId) {
            this.searchForm.media.id = rParams.mediaId
            this.searchForm.media.name = rParams.name
        }
        this.fetchReporters()
    }

    private async fetchReporters({ error }: {
        error?: () => void
    } = {}) {
        const params = { 
            type: this.curType,
            news_count: this.limitCount,
            media_id: this.searchForm.media.id,
            reporter_name: this.searchForm.reporterName,
            page_index: this.pageIndex, 
            page_size: this.pageSize 
        }
        const result = await ReporterService.getList(params)
        this.loading = false
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.reporters = result.data.reporters
            this.tableHeaderDecs = '一共有 ' + this.pageTotal + ' 位记者'
            return
        }
        error && error()
        this.$merror(result.message || '发生错误, 请稍后再试')
    }

    public handleRemoteSearch(query: string) {
        if (!query.trim()) {
            this.mediasOptions = []
            return
        }
        if (this.searchTimer) {
            clearTimeout(this.searchTimer)
        }
        this.searchTimer = window.setTimeout(() => {
            this.executeSearch(query)
        }, 300)
    }

    public async executeSearch(query: string) {
        this.lastSearchQuery = query
        this.mediaSearchLoading = true
        try {
            const result = await MediaService.searchMedia({ value: query })
            if (result.status === 200 && this.lastSearchQuery === query) {
                const medias = result.data.list.map((item: any) => {
                    return { value: item.id, label: item.name }
                })
                this.mediasOptions = medias
            }
        } catch (error) {
            this.$merror('搜索媒体失败，请稍后重试')
        } finally {
            this.mediaSearchLoading = false
        }
    }

    private removeReporter(reporter: any) {
        this.reporters.splice(this.reporters.findIndex(item => item.id === reporter.id), 1)
    }

    private onSelectSuggestion(media: any) {
        this.searchForm.media.id = media.value
    }

    private onCurrentChange(page: any) {
        this.prePage = this.pageIndex
        this.pageIndex = page
        this.scrollEl.scrollToTop(() => {
            this.fetchReporters({
                error: () => {
                    this.pageIndex = this.prePage
                }
            })
        })
    }

    private onSearch() {
        this.pageIndex = 1
        this.loading = true 
        this.fetchReporters()
    }

    private onCreate() {
        this.$router.push({ name: 'ReporterCreate' })
    }

    onReset() {
        this.curType = ''
        this.limitCount = ''
        this.searchForm.media.name = ''
        this.searchForm.media.id = ''
        this.searchForm.reporterName = ''
        this.fetchReporters()
    }
}
